import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Base
import Avatar from '../../../../../base/avatar';
import SlideDown from '../../../../../base/slide_down';

export default class Show extends React.Component {
  static propTypes = {
    experienceEntry: PropTypes.object.isRequired,
  }

  render() {
    const { experienceEntry } = this.props;
    return (
      <div className='flex'>
        <div>
          <Avatar {...{
            src: experienceEntry.company_logo,
            size: 'sm',
            isOrganization: true,
          }} />
        </div>
        <div className='flex-row margin-left-10'>
          <div>
            {experienceEntry.company_name}
          </div>
          <div className='xsm-font gray-900'>
            {experienceEntry.title}
          </div>
          <div className='xxsm-font gray-900'>
            {moment(experienceEntry.start_date).format('MMM. YYYY')}
            <span className='margin-left-5 margin-right-5'>-</span>
            {(experienceEntry.current || !experienceEntry.end_date) ? 'Present' : moment(experienceEntry.end_date).format('MMM. YYYY')}
          </div>
          {
            experienceEntry.description_markdown &&
            <div className='xxsm-font margin-top-5'>
              <SlideDown minHeight={80} margin-top-5>
                <div
                  className='wysiwyg-content'
                  dangerouslySetInnerHTML={{ __html: experienceEntry.description_markdown }}
                />
              </SlideDown>
            </div>
          }
        </div>
      </div>
    )
  }
}